// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"378":"3a70ada4","562":"b563c653","963":"d719b153"}[chunkId] + ".chunk.js";
};